import { render, staticRenderFns } from "./tasting-tube.vue?vue&type=template&id=a9ed11ac"
import script from "./tasting-tube.vue?vue&type=script&lang=js"
export * from "./tasting-tube.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports